export default function Input({label,label2=null, type, className,lableClass, placeholder, formik, name, dir, disabled = false, readOnly = false, ref, value = null,onBlur=null,icon= null,clickIcon=null,onChange=null,inputMode=null,iconText=null}) {
    const handleBlur = (e) => {
        if(onBlur!==null){
            onBlur()
        }
        formik.handleBlur(e);
    };
    return (
        <div className="mb-3 position-relative">
            {
                label && <label className="form-label">{label}</label>
            }
            {
                label2 && <span className={`form-label text-success text-end w-100 ${lableClass}`}> ( {label2} ) </span>
            }
            <div className="input-group ">
            <input type={type} className={`form-control ${className} ${formik.errors[name] && formik.touched[name] ? "is-invalid" : ""}`} dir={dir}
                   name={name} placeholder={placeholder} value={value || formik.values[name]?value?value:formik.values[name]:""}
                   onChange={onChange?onChange:formik.handleChange} disabled={disabled} onBlur={handleBlur} readOnly={readOnly} ref={ref ? ref : null}
                   autoComplete="off" inputMode={inputMode}
            />
                {iconText !== null ?
                    <span className="input-group-text cursor-pointer"  ><i className={`bx `}></i>{iconText}</span>
                    :
                    ""
                }
                {icon !== null ?
                    <span className="input-group-text cursor-pointer" onClick={clickIcon} ><i className={`bx ${icon}`}></i></span>
                    :
                    ""
                }
            {
                formik.touched[name] && formik.errors[name] ? (<div className="invalid-feedback">{formik.errors[name]}</div>) : null
            }
            </div>
        </div>

    )
}